// -- Prüft of IE11 oder kleiner
function isIE() {
  const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); //IE 11
  return (msie > 0 || trident > 0);
}

// -- Hinweis, sofern IE11 oder kleiner
window.onload = function() {
  if (isIE()) {
    var outerContainer = document.createElement('div');
    outerContainer.className = 'container-fluid';
    outerContainer.innerHTML = '<div class="alert alert-warning my-3">' +
      '<span class="ba-heading">Ihr Browser ist veraltet.</span> ' +
      '<p><a href="https://www.arbeitsagentur.de/hilfe" target="_blank">Hier</a> finden Sie eine Liste der unterstützten Browser.</p>' +
      '</div>';

    var mainTag = document.getElementById('main')
    mainTag.appendChild(outerContainer)
  }
}
